/* ============================================
   SMITH'S BLADES — MEMBERSHIP GATE
   v1.0 | Cronix Solutions
   Phase 1: Hardcoded ID validation
   Phase 2: Shopify Customer metafields (future)
   ============================================ */

(function () {
  'use strict';

  /* ——————————————————————————————————————
     VALID MEMBER IDS — Phase 1
     NOTE: Move to server-side in Phase 2
     —————————————————————————————————————— */
  const VALID_IDS = new Set([
    'SB-GUILD-001',
    'SB-GUILD-002',
    'SB-GUILD-003',
    'SB-GUILD-004',
    'SB-GUILD-005',
    'SB-FORGE-001',
    'SB-FORGE-002',
    'SB-FORGE-003',
    'SB-VAULT-001',
    'SB-VAULT-002',
    'SB-MASTER-001',
    'SB-MASTER-002',
    'SB-LEGEND-001'
  ]);

  /* ——————————————————————————————————————
     ELEMENT REFERENCES
     —————————————————————————————————————— */
  const input     = document.getElementById('memberIdInput');
  const errorEl   = document.getElementById('gateError');
  const submitBtn = document.getElementById('gateSubmitBtn');

  /* Gate only runs if it exists on the current page */
  if (!input) return;

  /* ——————————————————————————————————————
     AUTO RESTORE — if already unlocked
     this browser session
     —————————————————————————————————————— */
  const savedId = sessionStorage.getItem('sb_member_id');

  if (savedId && VALID_IDS.has(savedId)) {
    instantUnlock(savedId);
    return;
  }

  /* ——————————————————————————————————————
     INPUT — sanitize to uppercase + valid
     characters only
     —————————————————————————————————————— */
  input.addEventListener('input', function () {
    this.value = this.value
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, '');
    clearError();
  });

  /* ——————————————————————————————————————
     ENTER KEY — submit on Enter press
     —————————————————————————————————————— */
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      verifyMemberId();
    }
  });

  /* ——————————————————————————————————————
     VERIFY — main validation function
     exposed to global scope for onclick
     —————————————————————————————————————— */
  window.verifyMemberId = function () {
    const val = input.value.trim().toUpperCase();

    /* Empty check */
    if (!val) {
      showError('Please enter your Member ID.');
      return;
    }

    /* Invalid ID */
    if (!VALID_IDS.has(val)) {
      showError('Invalid Member ID. Please check and try again.');
      input.classList.add('error');
      setTimeout(function () {
        input.classList.remove('error');
      }, 500);
      return;
    }

    /* Valid — unlock the vault */
    animatedUnlock(val);
  };

  /* ——————————————————————————————————————
     ANIMATED UNLOCK — with visual effects
     —————————————————————————————————————— */
  function animatedUnlock(memberId) {

    /* Disable button immediately */
    if (submitBtn) {
      submitBtn.textContent    = 'Verified — Unlocking...';
      submitBtn.style.background = 'rgba(201,168,76,0.5)';
      submitBtn.style.cursor   = 'default';
      submitBtn.onclick        = null;
    }

    /* Flash the success ring */
    const ring = document.getElementById('gateRing');
    if (ring) ring.classList.add('flash');

    /* Swap lock icon to unlocked state */
    const lockIcon = document.getElementById('gateLockIcon');
    if (lockIcon) {
      lockIcon.innerHTML = [
        '<svg viewBox="0 0 24 24" fill="none"',
        '  stroke="#C9A84C" stroke-width="1.5"',
        '  stroke-linecap="round" stroke-linejoin="round">',
        '  <rect x="3" y="11" width="18" height="11" rx="2"/>',
        '  <path d="M7 11V7a5 5 0 0 1 9.9-1"/>',
        '  <circle cx="12" cy="16.5" r="1.5"',
        '    fill="#C9A84C" stroke="none"/>',
        '</svg>'
      ].join('');
    }

    /* After short delay — fade gate out + remove blur */
    setTimeout(function () {
      const gate    = document.getElementById('memberGate');
      const content = document.getElementById('excContent');

      if (gate) {
        gate.style.transition = 'opacity 0.7s ease';
        gate.style.opacity    = '0';
      }

      if (content) {
        content.classList.remove('locked');
      }

      /* After fade completes */
      setTimeout(function () {
        if (gate) {
          gate.style.pointerEvents = 'none';
        }

        /* Show member badge */
        const badge   = document.getElementById('memberBadge');
        const badgeId = document.getElementById('memberBadgeId');

        if (badge)   badge.classList.add('show');
        if (badgeId) badgeId.textContent = memberId;

        /* Save to session so refresh keeps it unlocked */
        sessionStorage.setItem('sb_member_id', memberId);

      }, 500);

    }, 900);
  }

  /* ——————————————————————————————————————
     INSTANT UNLOCK — no animation
     used for session restore on page reload
     —————————————————————————————————————— */
  function instantUnlock(memberId) {
    const gate    = document.getElementById('memberGate');
    const content = document.getElementById('excContent');
    const badge   = document.getElementById('memberBadge');
    const badgeId = document.getElementById('memberBadgeId');

    if (gate) {
      gate.style.opacity       = '0';
      gate.style.pointerEvents = 'none';
    }

    if (content) content.classList.remove('locked');
    if (badge)   badge.classList.add('show');
    if (badgeId) badgeId.textContent = memberId;
  }

  /* ——————————————————————————————————————
     HELPERS
     —————————————————————————————————————— */
  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.classList.add('show');
    }
  }

  function clearError() {
    if (errorEl)  errorEl.classList.remove('show');
    if (input)    input.classList.remove('error');
  }

})();